import moment from "moment-timezone";
import ClassModel from "src/models/ClassModel";
import { EventModel } from "src/models/EventModel";
import { InvoiceItemModel } from "src/models/InvoiceItemModel";
import StudentAttendanceNoteModel from "src/models/StudentAttendanceNoteModel";
import UserModel from "src/models/UserModel";
import { Day, InstanceAttendancePayload, TimeType } from "types/code-generator";
import ClassTimeModel from "./ClassTimeModel";
import LocationModel from "./LocationModel";
import OrganizationModel from "./OrganizationModel";
import { ZoneModel } from "./ZoneModel";

export const isAttendance = (attendance): attendance is AttendanceModel =>
  attendance instanceof AttendanceModel;

class AttendanceModel {
  active: boolean;
  assignedBy: UserModel;
  assignedOn: Date;
  cancelled: boolean = false;
  checkIns: UserModel[] = [];
  class: ClassModel;
  classTime: ClassTimeModel;
  counts: InstanceAttendancePayload["counts"];
  createdAt: Date;
  date: Date = new Date();
  day: Day;
  displayNoteDelay: number = null;
  displayNoteDelayType: TimeType = null;
  displayNoteToParticipants: boolean = true;
  endTime: string;
  events: EventModel[] = [];
  excluded: UserModel[] = [];
  id: string;
  instructors: UserModel[] = [];
  instructorsAdded: UserModel[] = [];
  instructorsRemoved: UserModel[] = [];
  invoiceItems: InvoiceItemModel[] = [];
  internalNote: string = "";
  isSplit: number = 0;
  location: LocationModel;
  note: string = "";
  originalDate: Date;
  organization: OrganizationModel;
  startTime: string;
  students: UserModel[] = [];
  studentsAdded: UserModel[] = [];
  studentsAttended: UserModel[] = [];
  studentAttendanceNotes: StudentAttendanceNoteModel[];
  studentsRemoved: UserModel[] = [];
  updatedAt: Date;
  zone: ZoneModel;

  constructor(data: AttendanceModel | any) {
    Object.assign(this, data);

    if (data?.class) {
      this.class = new ClassModel(data.class);
    }
  }

  get dateTime() {
    const attendanceTime = moment(this.startTime || "00:00", "HH:mm");
    const attendanceServer = moment.utc(this.date);

    let attendanceDate = moment(this.date).set({
      year: attendanceServer.get("year"),
      month: attendanceServer.get("month"),
      date: attendanceServer.get("date"),
      hour: attendanceTime.get("hour"),
      minute: attendanceTime.get("minute"),
      second: attendanceTime.get("second"),
    });

    if (this.organization?.timezone) {
      attendanceDate = moment
        .tz(attendanceServer.format("YYYY-MM-DD"), this.organization.timezone)
        .set({
          hour: attendanceTime.get("hour"),
          minute: attendanceTime.get("minute"),
          second: attendanceTime.get("second"),
        });
    }

    return attendanceDate.toDate();
  }
}

export default AttendanceModel;
